import React from 'react';
import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';
import { formatCurrency } from '@src/scripts/util/currency';

const MaterialStep = ( {
	materials,
	selectedMaterialId,
	onSelectMaterial,
	currency,
	locale,
} ) => (
	<div className="roi-calculator__step roi-calculator__step--material">
		<h3>{ __( 'Select material', 'sprintray-roi-calculator' ) }</h3>
		<p className="roi-calculator__step-hint">
			{ __(
				'This sets the default material cost for every indication below — you can still fine-tune each row afterwards.',
				'sprintray-roi-calculator'
			) }
		</p>
		<ul className="roi-calculator__material-list">
			{ materials.map( ( material ) => (
				<li key={ material.id }>
					<label
						htmlFor={ `roi-calculator-material-${ material.id }` }
					>
						<input
							id={ `roi-calculator-material-${ material.id }` }
							type="radio"
							name="roi-calculator-material"
							checked={ material.id === selectedMaterialId }
							onChange={ () => onSelectMaterial( material ) }
						/>
						{ material.name }
						<span className="roi-calculator__material-cost">
							{ formatCurrency(
								material.costPerCase,
								currency,
								locale
							) }{ ' ' }
							/ { __( 'case', 'sprintray-roi-calculator' ) }
						</span>
					</label>
				</li>
			) ) }
		</ul>
	</div>
);

MaterialStep.propTypes = {
	materials: PropTypes.array.isRequired,
	selectedMaterialId: PropTypes.oneOfType( [
		PropTypes.number,
		PropTypes.string,
	] ),
	onSelectMaterial: PropTypes.func.isRequired,
	currency: PropTypes.string,
	locale: PropTypes.string,
};

export default MaterialStep;
